import React, { useEffect } from "react";
import WOW from "wowjs";
import "./Contact.css";

const Contact = () => {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  

  return (
    <section id="contact-section" class="page text-white parallax">
      
      
      <div class="cover"></div>
      <div class="container" style={{paddingTop:"40px", position:"relative", paddingBottom:"50px"}}>
                <div
                  class="page-header text-center wow fadeInDown"
                  data-wow-delay="0.4s"
                >
                  <h2 style={{ color: "aliceblue", fontSize:"50px" }}>Contact</h2>
                  <div class="devider"></div>
                </div>
              </div>
        
     
      <div class="contact wow bounceInRight" data-wow-delay="0.4s">
        <div class="container">
          <div class="row">
            <div class="col-sm-6" style={{justifyContent: "center"}}>
              <div class="contact-info">
                <h4>Our Address</h4>
                <ul class="contact-address">
                  <li>
                    <i class="fa fa-map-marker fa-lg"></i>&nbsp;33
                    Millward Road ,<br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Delarey ,<br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Randburg, 2092
                  </li>
                  <li>
                    <i class="fa fa-phone"></i>&nbsp; 084 538 2735
                  </li>
                  <li>
                    <i class="fa fa-phone"></i>&nbsp; 067 100 3660
                  </li>
                  <li>
                    <i class="fa fa-envelope"></i> pytexkanyama@gmail.com
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-sm-6" style={{justifyContent: "center"}}>
              <div class="contact-form">
                <h4>Write to us</h4>
                <form role="form">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control input-lg"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control input-lg"
                      placeholder="E-mail"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control input-lg"
                      placeholder="Subject"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <textarea
                      class="form-control input-lg"
                      rows="5"
                      placeholder="Message"
                      required
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    class="btn wow bounceInRight"
                    data-wow-delay="0.8s"
                  >
                    Send
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
